import { useQuery } from '@tanstack/react-query';
import getFeatures from '@api/features';
import { trackQueryError } from '@src/utils/sensor/apptracker';
import { initFeatureStore } from '@src/globalStore/featureStore';
import { useDispatch } from 'react-redux';
import { updateFeatures } from '@store/common/actions';

// common store updates could trigger side effects
let first = true;

const useFeatureFlags = ({ enabled = true }) => {

  const dispatch = useDispatch();

  // refetch and update FF every 5m
  const { isError, isFetched } = useQuery(['feature-flags'], async () => {
      const resp = await getFeatures({});
      if (resp.data) {
        initFeatureStore(resp.data);

        // backward compatibility with redux
        if(first) {
          dispatch(updateFeatures({...resp.data}));
          first = false;
        }
        return resp.data;
      }
      return null;
    },
    {
      refetchOnWindowFocus: false,
      retry: false,
      enabled,
      staleTime: Infinity,
      keepPreviousData: true,
      refetchInterval: 5 * 60 * 1000,
      notifyOnChangeProps: ['isError', 'isFetched'],
      onError: (err) => {
        trackQueryError({ type: 'feature-flags', err });
      },
    },
  );
  return { isError, isFetched };
};

export default useFeatureFlags;
